module.exports = __webpack_public_path__ + "static/20250415_Press_Release_Receipt_Consent_Solicitation_v2-64395829c2484d3c8d8540e60bf7f5a9.pdf";